import ActionType from './action-type'
import * as Actions from './actions'
import {type ThunkAction} from 'redux-thunk'

import {REST} from '../../../api'
import {Api} from '../../../api/Api'
import {type AppState} from '../../types/app-state'
import {type IncidentType} from '../../../pages/incidents-v3/contexts/types/incident-type'

const TYPES_ENDPOINT = '/api/v1/incidentResponses/types'
const requestIncidentTypes = (): Actions.RequestIncidentTypesAction => ({
    type: ActionType.REQUEST_INCIDENT_TYPES,
})
const setIncidentTypes = (data: IncidentType[]): Actions.ReceivedIncidentTypesAction => ({
    type: ActionType.RECEIVED_INCIDENT_TYPES,
    payload: data,
})

export function fetchIncidentTypeses(): ThunkAction<void, AppState, Api, Actions.Action> {
    return (dispatch) => {
        dispatch(requestIncidentTypes())

        REST.get(TYPES_ENDPOINT)
            .then((response) => {
                // TODO: Fix this the next time the file is edited.
                // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
                dispatch(setIncidentTypes(response.data))
            })
            .catch(() => dispatch(setIncidentTypes([] as IncidentType[])))
    }
}
